import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { useSpaceParams } from 'hooks'
import { fetchBooth } from '../fetchBoothSlice'

export default () => {
    const dispatch = useDispatch()
    const { eventSlug, spaceSlug } = useSpaceParams()

    return useCallback(() => (
        dispatch(fetchBooth({
            eventSlug,
            boothSlug: spaceSlug,
        }))
    ), [dispatch, eventSlug, spaceSlug])
}
